// Klient API doboru elektrycznego stringów. Wzorzec jak api/kits.js: publiczny,
// bezstanowy, zwraca {ok, data, error} zamiast rzucać wyjątkiem.
import { apiFetch } from './apiFetch'
const BASE = process.env.REACT_APP_ELECTRICAL_API_URL || '/api/v1/electrical'

const wyslij = async (sciezka, payload, bladDomyslny) => {
  let res
  try {
    res = await apiFetch(`${BASE}${sciezka}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
  } catch {
    return { ok: false, error: 'Brak połączenia z serwerem. Spróbuj ponownie.' }
  }
  let data = null
  try { data = await res.json() } catch { data = null }
  if (!res.ok) {
    return { ok: false, error: (data && data.detail) || bladDomyslny }
  }
  return { ok: true, data }
}

export const policzStringi = (payload) =>
  wyslij('/strings', payload, 'Nie udało się policzyć doboru.')

/**
 * Jeden falownik z tej samej półki, przy którym para spina się elektrycznie.
 *
 * Wołane DOPIERO gdy dobór zgłosi problem z prądem — backend przelicza dla
 * każdego kandydata pełny dobór, więc nie ma sensu pytać „na wszelki wypadek".
 */
export const znajdzZamiennikFalownika = (payload) =>
  wyslij('/alternatywa-falownika', payload, 'Nie udało się poszukać zamiennika.')
